import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { RouteService } from '@services/route.service';
import { ProductService } from '@services/product.service';
import { GlobalService } from '@services/global.service';
import { Product, Categ, SCateg, Gamme, Marque, Tag, Banner } from '@models/product';
import { Image } from '@models/image';
import { environment } from '@environments/environment';
import { UserService } from 'src/app/services/user.service';

declare var bootstrap: any;

@Component({
  selector: 'gob-product-form',
  templateUrl: './product-form.component.html',
  styleUrls: ['./product-form.component.scss']
})
export class ProductFormComponent implements OnInit {
  loading: boolean=false;
  error: string;
  msg: string;
  product: Product;
  page: number=0;
  isUsed: boolean=false;
  gammes: Gamme[]=[];
  stockRight: boolean=false;

  constructor(
    public route: RouteService,
    private pServ: ProductService,
    private router: ActivatedRoute,
    private gServ: GlobalService,
    private userServ: UserService
  ) {
    this.loading=true;
    this.product=new Product();
    this.stockRight=this.userServ.hasRight("productStocks");
    this.router.paramMap
      .pipe(
        switchMap(params => {
          if(params.get('id'))
            return this.pServ.getProduct(params.get('id'), true);
          else
            return of(new Product());
        })
      )
      .subscribe(product => {
        this.product=product;

        // When duplication, images must not be set for the duplicated product
        if(this.router.snapshot.queryParamMap.get('duplicate')){
          this.product.ident=null;
          this.product.mainImage = null;
        }

        // When duplication for used product, set default values
        if(this.router.snapshot.queryParamMap.get('duplicateUsed')){
          // Set used product gamme
          this.gServ.getClassification().subscribe((classes: { gammes: any[]; }) => {
            this.gammes=classes.gammes;
          });
          this.product.gamme = this.gammes.find(e => e.name == 'Occasion').ident;
          // Set all others default values
          this.product.ident=null;
          this.product.stocks = [];
          this.product.prixAchat = Math.floor(this.product.prices[0].prix * 0.43);
          let price = Math.ceil(this.product.prices[0].prix * 0.66);
          let firstPrice = this.product.prices[0];
          this.product.prices = [];
          this.product.prices.push(firstPrice);
          this.product.prices[0].discounted = firstPrice.prix;
          this.product.prices[0].prix = price;
          this.product.banners = [];
          this.product.name = 'Occasion - ' + this.product.name;
          this.product.limitOrder = 1;
          this.product.dispoFrns = 0;
          this.product.releaseDate = null;
          this.product.lowStock = 0;
          this.product.isUsed = true;
          this.product.details = '<p class="used-product"><i class="green fad fa-hands"></i><span> Seconde main</span> Ce jeu a été vérifié avec amour et refermé avec un ruban <span> | </span>Produit complet et en bon état</p>' + this.product.details;
          this.product.subtitle = 'Seconde main - Ce jeu a été vérifié avec amour et refermé avec un ruban.';
          // Barcode must be unique, so we set a 'O' right after the first digit for the used product
          this.product.barrecode = this.product.barrecode[0] + 'O' + this.product.barrecode.substring(1);
        }

        this.product.isDraft=(this.product.state=='draft');
        this.product.isRupture=(this.product.state=='rupture');
        this.loading=false;
      });

  }

  ngOnInit(): void {
    const triggerTabList=document.querySelectorAll('#product-tab button');
    triggerTabList.forEach(triggerEl => {
      const tabTrigger=new bootstrap.Tab(triggerEl);

      triggerEl.addEventListener('click', event => {
        event.preventDefault();
        tabTrigger.show();
      });
    });
  }

  /**
   * The main image of the product, or the default one if no main image is set.
   */
  get mainImage() {
    if(this.router.snapshot.queryParamMap.get('duplicate'))
      return null;

    return this.product.mainImage || null;
  }

  /**
   * Retrieves all images of the product that are not set as the main image.
   * @returns An array of images that are not marked as the main image.
   */
  get galleryImages() {
    if(this.router.snapshot.queryParamMap.get('duplicate')){
      return [];
    }

    return this.product.images || [];
  }

  getBadgeClass(){
    return {
      'text-bg-secondary': this.product.state=='draft',
      'text-bg-success': this.product.state=='actif',
      'text-bg-warning': this.product.state=='rupture'
    };
  }

  /**
   * Called when a file input is changed, either for the main image, or the gallery images.
   * @param event The event of the file input change.
   * @param type The type of the file input, either 'main' or 'gallery'.
   */
  onFileSelected(event: any, type: 'main' | 'gallery') {
    const files = event.target.files;

    if (type === 'main') {
      this.product.mainImageFile = files[0]; // Single file
    } else {
      this.product.imageFiles = files; // Multiple files
    }
  }


  /**
   * Called when the draft switch is changed.
   * @param event The event of the switch change.
   * Sets the product's state to 'draft' if the switch is on, 'actif' if it's off.
   * Also sets the product's isDraft property to the switch's checked status.
   */
  setDraft(event: any){
    if(event.target.checked)
      this.product.state='draft';
    else
      this.product.state='actif';
    this.product.isDraft=event.target.checked;
  }

  /* setRupture(event: any){
    if(event.target.checked)
      this.product.state='rupture';
    else
      this.product.state='actif';
    this.product.isRupture=event.target.checked;
  } */

  update(form: any){
    this.loading=true;
    let update: boolean=(this.product.ident!=null);
    if(this.product.video=="")
      this.product.video=null;

    this.pServ.setProduct(this.product).subscribe({
      next: (product: { images: any; }) => {
        this.msg='Modifications enregistrées';
        if(!update){
          this.product=new Product();
          form.reset();
        }
        else{
          this.product.images=product.images;
          this.product.imageFiles=[];
          this.page=0;
        }
        this.loading=false;
      },
      error: e => {
        this.error=e;
        this.loading=false;
      }
    });
  }

  rm(){
    if(confirm('Etes-vous sûr de vouloir supprimer ?')){
      this.loading=true;
      this.pServ.rmProduct(this.product.ident).subscribe({
        next: () => {
          this.loading=false;
          this.route.navigate('product-list');
        },
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
    }
  }

  /**
   * Returns the URL of the image.
   * @param image Product image.
   * @returns Image URL.
   */
  getImage(image : any){
    return `${environment.imgUrl}/product/${image.name}`;
  }

  /**
   * Removes an image from the product.
   * @param from The origin of the image to remove, either 'main' for the main image or null for a gallery image.
   */
  rmImage(from: string | null = null, index: number | null = null){
    if(!this.product.rmImages)
      this.product.rmImages=[];

    // Removes the image from the main image and the product
    if (from === 'main') {
      this.product.rmImages.push(this.product.mainImage.ident);
      this.product.mainImage = null;
    } else {
      // Removes the image from the gallery at the given index
      const targetIndex = index !== null ? index : this.page;
      this.product.rmImages.push(this.product.images[targetIndex].ident);
      const rmIdent = this.product.images[targetIndex].ident;
      const idx = this.product.images.findIndex((img: { ident: string; }) => String(img.ident) === String(rmIdent));
      if (idx !== -1) {
        this.product.images.splice(idx, 1);
      }
    }
  }

}
